// import { useState, useCallback } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { Box, Typography, Button } from "@mui/material";
// import DownloadIcon from "@mui/icons-material/Download";
// import { importExcel } from "../redux/donorSlice";
// import { importExistingDonors } from "../redux/donorSlice";
// import { clearImportData } from "../redux/donorSlice";
// import ImportExcelCard from "../components/ImportDataList/ImportExcelCard";
// import ImportExcelModal from "../components/ImportDataList/ImportExcelModal";
// import ImportDataList from "../components/ImportDataList/ImportDataList";
// import { usePageLogger } from "../hooks/usePageLogger";
// import CardWithDropdown from "../components/ImportDataList/CardwithDropdown";
// import { logger } from "../utils/logger";
// import SnackbarAlert from "../components/SnackBarAlert";

// const ImportDataPage = () => {
//   const dispatch = useDispatch();
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [isOpen, setIsOpen] = useState(false);
//   const [isExistingOpen, setIsExistingOpen] = useState(false);
//   const { loading } = useSelector((state) => state.donor);
//   const { user } = useSelector((state) => state.auth);
//   const [feedback, setFeedback] = useState({
//     open: false,
//     message: "",
//     severity: "info",
//   });

//   usePageLogger("Import Page", { username: user?.username, role: user?.role });

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       setSelectedFile(file);
//       logger.info("File Selected ", {
//         username: user?.username,
//         role: user?.role,
//         file: file.name,
//       });
//     }
//   };



//   const handleCloseFeedback = useCallback(() => {
//     setFeedback({ ...feedback, open: false });
//   }, []);

//   const handleImportSubmit = async () => {
//     if (!selectedFile) {
//       logger.warn("Submitted before selecting the file", {
//         username: user?.username,
//         role: user?.role,
//       });
//       setFeedback({
//         open: true,
//         message: "Please select a file before importing",
//         severity: "warning",
//       });
//       return;
//     }
//     dispatch(clearImportData());
//     setIsOpen(false);
//     try {
//       const result = await dispatch(importExcel(selectedFile)).unwrap();
//       if (result && result.errors && result.errors.length > 0) {
//         logger.error("Failed to Import donors and donations excel", {
//           username: user?.username,
//           role: user?.role,
//           error: result.errors,
//         });
//         setFeedback({
//           open: true,
//           message: result.errors[0].error || "Some records failed to import",
//           severity: "error",
//         });
//       } else {
//         logger.info("Donors and Donation Excel imported successfully", {
//           username: user?.username,
//           role: user?.role,
//         });
//         setFeedback({
//           open: true,
//           message: "Donors imported successfully",
//           severity: "success",
//         });
//         setSelectedFile(null);
//       }
//     } catch (error) {
//       if (error.status === 409) {
//         setFeedback({
//           open: true,
//           message: `${error.message}`,
//           severity: "warning",
//         });
//       } else {
//         setFeedback({
//           open: true,
//           message: "An error occurred, Please try again.",
//           severity: "error",
//         });
//         logger.info("Error occur during import donors and donations excel", {
//           username: user?.username,
//           role: user?.role,
//           error: error,
//         });
//       }
//     }
//   };

//   const handleImportExistingDonors = async () => {
//     if (!selectedFile) {
//       logger.warn("Submitted before selecting the file", {
//         username: user?.username,
//         role: user?.role,
//       });
//       setFeedback({
//         open: true,
//         message: "Please select a file before importing",
//         severity: "warning",
//       });
//       return;
//     }
//     dispatch(clearImportData());
//     setIsExistingOpen(false);
//     try {
//       const result = await dispatch(
//         importExistingDonors(selectedFile)
//       ).unwrap();
//       // Check if result contains errors
//       if (result && result.errors && result.errors.length > 0) {
//         logger.error("Failed to import new and existing donors excel", {
//           username: user?.username,
//           role: user?.role,
//           error: result.errors,
//         });
//         setFeedback({
//           open: true,
//           message: result.errors[0].error || "Some records failed to import.",
//           severity: "error",
//         });
//       } else {
//         logger.info("New and Existing Donors imported successfully", {
//           username: user?.username,
//           role: user?.role,
//           file: selectedFile.name,
//         });
//         setFeedback({
//           open: true,
//           message: "Donors imported successfully",
//           severity: "success",
//         });
//         setSelectedFile(null);
//       }
//     } catch (error) {
//       if (error.status === 409) {
//         setFeedback({
//           open: true,
//           message: `${error.message}`,
//           severity: "warning",
//         });
//       } else {
//         logger.error("Error occur during new and existing donor excel import", {
//           username: user?.username,
//           role: user?.role,
//           error: error,
//         });
//         setFeedback({
//           open: true,
//           message: "An error occurred, Please try again.",
//           severity: "error",
//         });
//       }
//     }
//   };

//   const handleDownload = (filePath, fileName) => {
//     const link = document.createElement("a");
//     link.href = filePath;
//     link.download = fileName;
//     link.click();
//   };

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         height: "100vh",
//         overflow: "hidden",
//       }}
//     >
//       {/* Left Column: Import Content */}
//       <Box sx={{ flexGrow: 1, padding: 3, overflow: "auto" }}>
//         <Typography variant="h4" gutterBottom sx={{ mb: 3 }}>
//           Import Excel Data
//         </Typography>

//         <div
//           style={{
//             display: "flex",
//             gap: "16px",
//             marginRight: "10px",
//             marginBottom: "0px",
//           }}
//         >
//           <ImportExcelCard
//             title="Import Recent Records"
//             content={
//               "Click to upload Latest Entries\n(New and Existing Donors)"
//             }
//             onClick={() => setIsExistingOpen(true)}
//           />
//           <CardWithDropdown />
//         </div>

//         <ImportDataList />
//       </Box>

//       {/* Right Sidebar: Templates - Full Height */}
//       <Box
//         sx={{
//           width: "300px",
//           height: "100vh",
//           backgroundColor: "#f5f5f5",
//           borderLeft: "1px solid #e0e0e0",
//           padding: 3,
//           boxShadow: "-2px 0 8px rgba(0,0,0,0.1)",
//           overflow: "auto",
//         }}
//       >
//         <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>
//           Download Templates
//         </Typography>

//         <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
//           <Button
//             variant="contained"
//             fullWidth
//             startIcon={<DownloadIcon />}
//             sx={{
//               justifyContent: "flex-start",
//               textTransform: "none",
//               backgroundColor: "#1976d2",
//               "&:hover": { backgroundColor: "#1565c0" },
//             }}
//             onClick={() =>
//               handleDownload(
//                 "/templates/Recent_Records_template.xlsx",
//                 "Recent_Records_template.xlsx"
//               )
//             }
//           >
//             Recent Record Template
//           </Button>

//           <Button
//             variant="contained"
//             fullWidth
//             startIcon={<DownloadIcon />}
//             sx={{
//               justifyContent: "flex-start",
//               textTransform: "none",
//               backgroundColor: "#1976d2",
//               "&:hover": { backgroundColor: "#1565c0" },
//             }}
//             onClick={() =>
//               handleDownload(
//                 "/templates/Update_Prasad_template.xlsx",
//                 "Update_Prasad_template.xlsx"
//               )
//             }
//           >
//             Prasad Template
//           </Button>

//           <Button
//             variant="contained"
//             fullWidth
//             startIcon={<DownloadIcon />}
//             sx={{
//               justifyContent: "flex-start",
//               textTransform: "none",
//               backgroundColor: "#1976d2",
//               "&:hover": { backgroundColor: "#1565c0" },
//             }}
//             onClick={() =>
//               handleDownload(
//                 "/templates/Update_Status_template.xlsx",
//                 "Update_Status_template.xlsx"
//               )
//             }
//           >
//             Status Template
//           </Button>

//           <Button
//             variant="contained"
//             fullWidth
//             startIcon={<DownloadIcon />}
//             sx={{
//               justifyContent: "flex-start",
//               textTransform: "none",
//               backgroundColor: "#1976d2",
//               "&:hover": { backgroundColor: "#1565c0" },
//             }}
//             onClick={() =>
//               handleDownload(
//                 "/templates/Update_Location_template.xlsx",
//                 "Update_Location_template.xlsx"
//               )
//             }
//           >
//             Location Template
//           </Button>
//         </Box>
//       </Box>

//       {/* Modals */}
//       <ImportExcelModal
//         open={isOpen}
//         onClose={() => setIsOpen(false)}
//         onFileChange={handleFileChange}
//         onSubmit={handleImportSubmit}
//       />
//       <ImportExcelModal
//         open={isExistingOpen}
//         onClose={() => setIsExistingOpen(false)}
//         onFileChange={handleFileChange}
//         onSubmit={handleImportExistingDonors}
//       />

//       <SnackbarAlert feedback={feedback} onClose={handleCloseFeedback} />
//     </Box>
//   );
// };

// export default ImportDataPage;
import { useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography, Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { importExcel } from "../redux/donorSlice";
import { importExistingDonors } from "../redux/donorSlice";
import { clearImportData } from "../redux/donorSlice";
import ImportExcelCard from "../components/ImportDataList/ImportExcelCard";
import ImportExcelModal from "../components/ImportDataList/ImportExcelModal";
import ImportDataList from "../components/ImportDataList/ImportDataList";
import { usePageLogger } from "../hooks/usePageLogger";
import CardWithDropdown from "../components/ImportDataList/CardwithDropdown";
import { logger } from "../utils/logger";
import SnackbarAlert from "../components/SnackBarAlert";

const ImportDataPage = () => {
  const dispatch = useDispatch();
  const [selectedFile, setSelectedFile] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isExistingOpen, setIsExistingOpen] = useState(false);
  const { loading } = useSelector((state) => state.donor);
  const { user } = useSelector((state) => state.auth);
  const [feedback, setFeedback] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  usePageLogger("Import Page", { username: user?.username, role: user?.role });

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      logger.info(`File selected: ${file.name}`, {
        page: "Import Data",
        username: user?.username,
        role: user?.role,
        file: file.name,
      });
    }
  };



  const handleCloseFeedback = useCallback(() => {
    setFeedback({ ...feedback, open: false });
  }, []);

  const handleImportSubmit = async () => {
    if (!selectedFile) {
      logger.warn("Submitted before selecting the file", {
        page: "Import Data",
        username: user?.username,
        role: user?.role,
      });
      setFeedback({
        open: true,
        message: "Please select a file before importing",
        severity: "warning",
      });
      return;
    }
    dispatch(clearImportData());
    setIsOpen(false);
    try {
      const result = await dispatch(importExcel(selectedFile)).unwrap();
      if (result && result.errors && result.errors.length > 0) {
        logger.error("Failed to import donors and donations excel", {
          page: "Import Data",
          username: user?.username,
          role: user?.role,
          error: result.errors,
        });
        setFeedback({
          open: true,
          message: result.errors[0].error || "Some records failed to import",
          severity: "error",
        });
      } else {
        logger.info("Donors and Donation Excel imported successfully", {
          page: "Import Data",
          username: user?.username,
          role: user?.role,
        });
        setFeedback({
          open: true,
          message: "Donors imported successfully",
          severity: "success",
        });
        setSelectedFile(null);
      }
    } catch (error) {
      if (error.status === 409) {
        setFeedback({
          open: true,
          message: `${error.message}`,
          severity: "warning",
        });
      } else {
        setFeedback({
          open: true,
          message: "An error occurred, Please try again.",
          severity: "error",
        });
        logger.error("Error during import donors and donations excel", {
          page: "Import Data",
          username: user?.username,
          role: user?.role,
          error: error,
        });
      }
    }
  };

  const handleImportExistingDonors = async () => {
    if (!selectedFile) {
      logger.warn("Submitted before selecting the file", {
        page: "Import Data",
        username: user?.username,
        role: user?.role,
      });
      setFeedback({
        open: true,
        message: "Please select a file before importing",
        severity: "warning",
      });
      return;
    }
    dispatch(clearImportData());
    setIsExistingOpen(false);
    try {
      const result = await dispatch(
        importExistingDonors(selectedFile)
      ).unwrap();
      // Check if result contains errors
      if (result && result.errors && result.errors.length > 0) {
        logger.error("Failed to import new and existing donors excel", {
          username: user?.username,
          role: user?.role,
          error: result.errors,
        });
        setFeedback({
          open: true,
          message: result.errors[0].error || "Some records failed to import.",
          severity: "error",
        });
      } else {
        logger.info("New and Existing Donors imported successfully", {
          page: "Import Data",
          username: user?.username,
          role: user?.role,
          file: selectedFile.name,
        });
        setFeedback({
          open: true,
          message: "Donors imported successfully",
          severity: "success",
        });
        setSelectedFile(null);
      }
    } catch (error) {
      if (error.status === 409) {
        setFeedback({
          open: true,
          message: `${error.message}`,
          severity: "warning",
        });
      } else {
        logger.error("Error during new and existing donor excel import", {
          page: "Import Data",
          username: user?.username,
          role: user?.role,
          error: error,
        });
        setFeedback({
          open: true,
          message: "An error occurred, Please try again.",
          severity: "error",
        });
      }
    }
  };

  const handleDownload = (filePath, fileName) => {
    const link = document.createElement("a");
    link.href = filePath;
    link.download = fileName;
    link.click();
  };

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      {/* Left Column: Import Content */}
      <Box sx={{ flexGrow: 1, padding: 3, overflow: "auto" }}>
        <Typography variant="h4" gutterBottom sx={{ mb: 3 }}>
          Import Excel Data
        </Typography>

        <div
          style={{
            display: "flex",
            gap: "16px",
            marginRight: "10px",
            marginBottom: "0px",
          }}
        >
          <ImportExcelCard
            title="Import Recent Records"
            content={
              "Click to upload Latest Entries\n(New and Existing Donors)"
            }
            onClick={() => setIsExistingOpen(true)}
          />
          <CardWithDropdown />
        </div>

        <ImportDataList />
      </Box>

      {/* Right Sidebar: Templates - Full Height */}
      <Box
        sx={{
          width: "300px",
          height: "100vh",
          backgroundColor: "#f5f5f5",
          borderLeft: "1px solid #e0e0e0",
          padding: 3,
          boxShadow: "-2px 0 8px rgba(0,0,0,0.1)",
          overflow: "auto",
        }}
      >
        <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>
          Download Templates
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Button
            variant="contained"
            fullWidth
            startIcon={<DownloadIcon />}
            sx={{
              justifyContent: "flex-start",
              textTransform: "none",
              backgroundColor: "#1976d2",
              "&:hover": { backgroundColor: "#1565c0" },
            }}
            onClick={() =>
              handleDownload(
                "/templates/Recent_Records_template.xlsx",
                "Recent_Records_template.xlsx"
              )
            }
          >
            Recent Record Template
          </Button>

          <Button
            variant="contained"
            fullWidth
            startIcon={<DownloadIcon />}
            sx={{
              justifyContent: "flex-start",
              textTransform: "none",
              backgroundColor: "#1976d2",
              "&:hover": { backgroundColor: "#1565c0" },
            }}
            onClick={() =>
              handleDownload(
                "/templates/Update_Prasad_template.xlsx",
                "Update_Prasad_template.xlsx"
              )
            }
          >
            Prasad Template
          </Button>

          <Button
            variant="contained"
            fullWidth
            startIcon={<DownloadIcon />}
            sx={{
              justifyContent: "flex-start",
              textTransform: "none",
              backgroundColor: "#1976d2",
              "&:hover": { backgroundColor: "#1565c0" },
            }}
            onClick={() =>
              handleDownload(
                "/templates/Update_Status_template.xlsx",
                "Update_Status_template.xlsx"
              )
            }
          >
            Status Template
          </Button>

          <Button
            variant="contained"
            fullWidth
            startIcon={<DownloadIcon />}
            sx={{
              justifyContent: "flex-start",
              textTransform: "none",
              backgroundColor: "#1976d2",
              "&:hover": { backgroundColor: "#1565c0" },
            }}
            onClick={() =>
              handleDownload(
                "/templates/Update_Location_template.xlsx",
                "Update_Location_template.xlsx"
              )
            }
          >
            Location Template
          </Button>
        </Box>
      </Box>

      {/* Modals */}
      <ImportExcelModal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        onFileChange={handleFileChange}
        onSubmit={handleImportSubmit}
      />
      <ImportExcelModal
        open={isExistingOpen}
        onClose={() => setIsExistingOpen(false)}
        onFileChange={handleFileChange}
        onSubmit={handleImportExistingDonors}
      />

      <SnackbarAlert feedback={feedback} onClose={handleCloseFeedback} />
    </Box>
  );
};

export default ImportDataPage;
